import { ReactNode, useContext } from 'react';
import { ConfirmationContext } from '../components/context/ConfirmationContext';

const useConfirmation = () => {
  const { confirm } = useContext(ConfirmationContext);

  const handleConfirmation = (
    title: string,
    message: ReactNode,
    onConfirm?: any,
    options?: { confirmColor?: 'error' },
  ) => {
    confirm(title, message, onConfirm, options);
  };

  return { handleConfirmation };
};

export default useConfirmation;
